import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from 'App';
import './index.css';

import { persistor, store } from 'redux/store';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { PersistGate } from 'redux-persist/integration/react';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

ReactDOM.createRoot(document.getElementById('root')).render(
  // <React.StrictMode>

  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <BrowserRouter basename="goit-react-hw-08-phonebook">
        <App />
        <ToastContainer autoClose={2000} />
      </BrowserRouter>
    </PersistGate>
  </Provider>

  // </React.StrictMode>
);
